// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
  --background: white !important;
}

.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  display: none;
}
.promo-info .name {
  width: 180px;
}

.min-order {
  margin: 10px 10px 0;
}

.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding-inline: 7px;
  cursor: pointer;
  border-radius: 22px;
  background-color: #fff;
  padding: 10px;
}
.add-more .add-text {
  font-family: AppFontBold;
  font-size: 11px;
  line-height: 13px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.add-more .add-button {
  margin-right: 12px;
}

.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-button.invalid {
  --background: darkgrey;
  color: grey;
}

.wrapper {
  max-height: 100%;
  flex-direction: column;
  display: flex;
  height: 100%;
  background: black url('background.png') no-repeat center center/100% 100% !important;
  background-size: cover;
}

.order-list {
  margin-block: 12px;
  width: 100%;
}
@media (min-width: 400px) {
  .order-list {
    max-height: 260px;
    overflow: auto;
  }
}

.promo-code {
  width: 100%;
  margin-block: 12.5px;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
}

.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

.ordered-articles {
  flex: 1;
  overflow: auto;
  padding: 16px 17px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ordered-articles-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
  padding: 18px 13px;
  margin-bottom: 13px;
}

.title {
  font-family: AppFontBold;
  font-size: 25px;
  line-height: 21px;
  text-align: center;
  color: #000;
  margin-bottom: 18px;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-image: url('dot.svg');
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.total .total-title {
  font-family: AppFontBold;
  font-size: 14px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.total .total-sum {
  font-family: AppFontBold;
  font-size: 13px;
  text-align: right;
  color: #000;
}

.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}

.add-to-order-button {
  margin: 4px 12px 12px 12px;
}

app-payment-methods-display {
  margin: 0 12px;
  display: block;
}

.from-menu .title {
  color: var(--ion-color-dark);
}

.points {
  padding: 9px 18px;
  width: 100%;
  margin-bottom: 12px;
}
.points_info {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 12px;
}
.points_info .info_section {
  display: flex;
  align-items: flex-start;
}
.points_info .info_section .points_text {
  margin-left: 10px;
}
.points_info ion-img {
  width: 62px;
  height: 20px;
}
.points .img-info {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: left;
  color: #000000;
  text-transform: capitalize;
}
.points_text {
  display: flex;
  flex-direction: column;
  width: 54%;
}
.points_title {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 15px;
  text-align: left;
  color: #000000;
}
.points_description {
  font-family: AppFont;
  font-size: 12px;
  line-height: 15px;
  text-align: left;
  color: #000000;
  margin-top: 5px;
}
.points_current {
  height: 45px;
  width: 45px;
  border: 4px dotted black;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.points_quantity {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: left;
  color: #000;
}
.points .buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.points .buttons_button {
  width: 100%;
  height: 30px;
  background-color: var(--ion-color-primary);
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #fff;
}
.points .buttons_button:last-child {
  background-color: transparent;
  color: var(--ion-color-primary);
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 17px;
  background: white;
}
.footer__select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.footer__select-info {
  width: 45%;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
  color: #000;
}
.footer ion-radio-group {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.footer ion-radio-group ion-radio {
  --border-width: 1px;
  --border-color: #000;
  --border-color-checked: #000;
  --background-checked: transparent;
  --color-checked: #000;
  --color: #000;
}
.footer ion-radio-group .radio-checked::part(mark) {
  transform: scale3d(1.4, 1.4, 1);
}
.footer .button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.footer .button-row .footer-btn {
  margin-top: 12px;
  min-height: 46px;
  height: 46px;
  width: max-content;
  position: relative;
  --padding-start: 5px;
  --padding-end: 5px;
  --padding-top: 5px;
  --padding-bottom: 5px;
}
.footer .button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  color: #fff;
}
.footer .button-row .footer-btn .button-img {
  width: 35px;
  height: 35px;
  right: 0;
  top: 0;
  bottom: 0;
}
.footer .button-row .button-total {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: min-content;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #000;
  text-transform: uppercase;
  margin-left: auto;
}
.footer .button-row .button-total span {
  font-family: AppFontBold;
  font-size: 18px;
  color: #000;
}

.no-articles {
  display: flex;
}
.no-articles ion-icon {
  color: white;
  fill: white;
  margin-right: 10px;
  display: none;
}
@media (min-width: 991px) {
  .no-articles ion-icon {
    fill: black;
    color: black;
  }
}
@media (min-width: 991px) {
  .no-articles ion-icon.big-screen {
    display: block;
  }
}
@media (max-width: 992px) {
  .no-articles ion-icon.small-screen {
    display: block;
  }
}
.no-articles h3 {
  color: white;
}

.age-verified {
  color: var(--ion-color-primary);
  margin-bottom: 10px;
  background: #ffffff;
}
.age-verified ion-item {
  border: none;
  align-items: flex-start;
}
.age-verified ion-item label {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
}

.error-message {
  color: var(--ion-color-primary);
  text-align: center;
  padding: 20px;
}

.delivery {
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  color: black !important;
}
.delivery span {
  color: black;
  font-family: AppFontBold;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;EACA,8BAAA;AADD;;AAIA;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,aAAA;AAND;AAEC;EACC,YAAA;AAAF;;AAMA;EACC,mBAAA;AAHD;;AAMA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AAHD;AAIC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AAFF;AAKC;EACC,kBAAA;AAHF;;AAOA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAJD;;AAOA;EACC,sBAAA;EACA,WAAA;AAJD;;AAOA;EACC,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EAEC,oFAAA;EACA,sBAAA;AALF;;AASA;EACC,kBAAA;EACA,WAAA;AAND;AAOC;EAHD;IAIE,iBAAA;IACA,cAAA;EAJA;AACF;;AAOA;EACC,WAAA;EACA,oBAAA;EACA,wDAAA;AAJD;;AAMA;EACC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHD;ACpFE;EDkFF;IAOE,YAAA;EADA;AACF;;AAIA;EACC,OAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADD;;AAIA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wDAAA;EACA,kBAAA;EACA,mBAAA;AADD;;AAIA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AADD;;AAIA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AADD;AAGC;EACC,WAAA;EACA,gCAAA;EACA,yBAAA;AADF;AAGC;EACC,yBAAA;AADF;;AAKA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAFD;AAIC;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AAFF;AAIC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAFF;;AAMA;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAHD;;AAMA;EACC,0BAAA;AAHD;;AAMA;EACC,cAAA;EACA,cAAA;AAHD;;AAOC;EACC,4BAAA;AAJF;;AAQA;EAGC,iBAAA;EACA,WAAA;EACA,mBAAA;AAPD;AASC;EACC,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;AAPF;AAQE;EACC,aAAA;EACA,uBAAA;AANH;AAOG;EACC,iBAAA;AALJ;AAQE;EACC,WAAA;EACA,YAAA;AANH;AAUC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AARF;AAWC;EACC,aAAA;EACA,sBAAA;EACA,UAAA;AATF;AAYC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAVF;AAaC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAXF;AAcC;EACC,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbF;AAgBC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAdF;AAiBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAfF;AAiBE;EACC,WAAA;EACA,YAAA;EACA,0CAAA;EACA,4CAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAhBH;AAkBG;EACC,6BAAA;EACA,+BAAA;AAhBJ;;AAsBA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;AAnBD;AAoBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAlBF;AAqBC;EACC,UAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAnBF;AAsBC;EACC,UAAA;EACA,aAAA;EACA,yBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AArBF;AAsBE;EACC,mBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;AArBH;AAuBE;EACC,+BAAA;AArBH;AAyBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAvBF;AAyBE;EACC,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAvBH;AAwBG;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAtBJ;AAyBG;EACC,WAAA;EACA,YAAA;EAEA,QAAA;EACA,MAAA;EACA,SAAA;AAxBJ;AA4BE;EACC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;AA1BH;AA2BG;EACC,wBAAA;EACA,eAAA;EACA,WAAA;AAzBJ;;AA+BA;EACC,aAAA;AA5BD;AA6BC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EAMA,aAAA;AAhCF;AC1XE;EDiZD;IAME,WAAA;IACA,YAAA;EAzBD;AACF;AChYE;ED2ZA;IAEE,cAAA;EAzBF;AACF;AC/XE;ED2ZA;IAEE,cAAA;EA1BF;AACF;AA+BC;EACC,YAAA;AA7BF;;AAiCA;EAEC,+BAAA;EACA,mBAAA;EACA,mBAAA;AA/BD;AAgCC;EACC,YAAA;EACA,uBAAA;AA9BF;AA+BE;EACC,oCAAA;EACA,eAAA;AA7BH;;AAkCC;EACA,+BAAA;EACG,kBAAA;EACA,aAAA;AA/BJ;;AAiCC;EACA,kBAAA;EACG,WAAA;EACA,aAAA;EAEA,uBAAA;EACA,aAAA;EACA,uBAAA;AA/BJ;AAgCC;EACC,YAAA;EACA,wBAAA;EACA,eAAA;AA9BF","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\tpadding: 0 10px;\n\t--background: white !important;\n}\n\n.promo-info {\n\talign-items: center;\n\tpadding: 10px 17px;\n\tbackground: white;\n\tmargin: 10px 10px 0;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\n\t.name {\n\t\twidth: 180px;\n\t}\n\n\tdisplay: none;\n}\n\n.min-order {\n\tmargin: 10px 10px 0;\n}\n\n.add-more {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\theight: 34px;\n\tmin-width: fit-content;\n\tpadding-inline: 7px;\n\tcursor: pointer;\n\tborder-radius: 22px;\n\tbackground-color: #fff;\n\tpadding: 10px;\n\t.add-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.add-button {\n\t\tmargin-right: 12px;\n\t}\n}\n\n.card-actions {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n.footer-button.invalid {\n\t--background: darkgrey;\n\tcolor: grey;\n}\n\n.wrapper {\n\tmax-height: 100%;\n\tflex-direction: column;\n\tdisplay: flex;\n\theight: 100%;\n\n\t\tbackground: black url(../../../assets/background/background.png)  no-repeat center center / 100% 100% !important;\n\t\tbackground-size: cover;\n\n}\n\n.order-list {\n\tmargin-block: 12px;\n\twidth: 100%;\n\t@media (min-width: 400px) {\n\t\tmax-height: 260px;\n\t\toverflow: auto;\n\t}\n}\n\n.promo-code {\n\twidth: 100%;\n\tmargin-block: 12.5px;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n}\n.article {\n\ttext-align: center;\n\theight: 110px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include mobile {\n\t\theight: 35px;\n\t}\n}\n\n.ordered-articles {\n\tflex: 1;\n\toverflow: auto;\n\tpadding: 16px 17px 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.ordered-articles-container {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tbackground-color: #fff;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\tpadding: 18px 13px;\n\tmargin-bottom: 13px;\n}\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 25px;\n\tline-height: 21px;\n\ttext-align: center;\n\tcolor: #000;\n\tmargin-bottom: 18px;\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n\t&--wide .line {\n\t\tbackground-size: 8px 100%;\n\t}\n}\n\n.total {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\tmargin-top: 19px;\n\n\t.total-title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\t.total-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 13px;\n\t\ttext-align: right;\n\t\tcolor: #000;\n\t}\n}\n\n.promo-error {\n\tmargin: 10px;\n\tfont-size: 13px;\n\ttext-align: center;\n\tcolor: red;\n\tdisplay: none;\n}\n\n.add-to-order-button {\n\tmargin: 4px 12px 12px 12px;\n}\n\napp-payment-methods-display {\n\tmargin: 0 12px;\n\tdisplay: block;\n}\n\n.from-menu {\n\t.title {\n\t\tcolor: var(--ion-color-dark);\n\t}\n}\n\n.points {\n\n\n\tpadding: 9px 18px;\n\twidth: 100%;\n\tmargin-bottom: 12px;\n\n\t&_info {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: stretch;\n\t\tmargin-bottom: 12px;\n\t\t.info_section {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\t.points_text {\n\t\t\t\tmargin-left: 10px;\n\t\t\t}\t\n\t\t}\n\t\tion-img {\n\t\t\twidth: 62px;\n\t\t\theight: 20px;\n\t\t}\n\t}\n\n\t.img-info {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t\ttext-transform: capitalize;\n\t}\n\n\t&_text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 54%;\n\t}\n\n\t&_title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size:18px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t}\n\n\t&_description {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t\tmargin-top: 5px;\n\t}\n\n\t&_current {\n\t\theight: 45px;\n\t\twidth: 45px;\n\t\t// background: url(../../../assets/losteria/doted_circle.png) no-repeat center center/ 100%;\n\t\tborder: 4px dotted black;\n\t\tborder-radius: 50%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&_quantity {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t}\n\n\t.buttons {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tgap: 10px;\n\n\t\t&_button {\n\t\t\twidth: 100%;\n\t\t\theight: 30px;\n\t\t\tbackground-color: var(--ion-color-primary);\n\t\t\tborder: 1.5px solid var(--ion-color-primary);\n\t\t\tborder-radius: 41px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 17px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\n\t\t\t&:last-child {\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: stretch;\n\tpadding: 17px;\n\tbackground: white;\n\t&__select {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t&__select-info {\n\t\twidth: 45%;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 12px;\n\t\tline-height: 14px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t}\n\n\tion-radio-group {\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t\tion-radio {\n\t\t\t--border-width: 1px;\n\n\t\t\t--border-color: #000;\n\t\t\t--border-color-checked: #000;\n\t\t\t--background-checked: transparent;\n\t\t\t--color-checked: #000;\n\t\t\t--color: #000;\n\t\t}\n\t\t.radio-checked::part(mark) {\n\t\t\ttransform: scale3d(1.4, 1.4, 1);\n\t\t}\n\t}\n\n\t.button-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\n\t\t.footer-btn {\n\t\t\tmargin-top: 12px;\n\t\t\tmin-height: 46px;\n\t\t\theight: 46px;\n\t\t\twidth: max-content;\n\t\t\tposition: relative;\n\t\t\t--padding-start: 5px;\n\t\t\t--padding-end: 5px;\n\t\t\t--padding-top: 5px;\n\t\t\t--padding-bottom: 5px;\n\t\t\t.footer-btn-text {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 14px;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: #fff;\n\t\t\t\t// margin-right: auto;\n\t\t\t}\n\t\t\t.button-img {\n\t\t\t\twidth: 35px;\n\t\t\t\theight: 35px;\n\t\t\t\t// margin-right: 7px;\n\t\t\t\tright: 0;\n\t\t\t\ttop: 0;\n\t\t\t\tbottom: 0;\n\t\t\t}\n\t\t}\n\n\t\t.button-total {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tjustify-content: flex-end;\n\t\t\twidth: min-content;\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 17px;\n\t\t\ttext-align: right;\n\t\t\tcolor: #000;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-left: auto;\n\t\t\tspan {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tcolor: #000;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.no-articles {\n\tdisplay: flex;\n\tion-icon {\n\t\tcolor: white;\n\t\tfill: white;\n\t\tmargin-right: 10px;\n\n\t\t@include desktop {\n\t\t\tfill: black;\n\t\t\tcolor: black;\n\t\t}\n\t\tdisplay: none;\n\t\t&.big-screen {\n\t\t\t@include desktop {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t}\n\t\t&.small-screen {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: block;\n\n\t\t\t}\n\n\t\t}\n\t}\n\th3 {\n\t\tcolor: white;\n\t\t\n\t}\n}\n.age-verified {\n\n\tcolor: var(--ion-color-primary);\n\tmargin-bottom: 10px;\n\tbackground: #ffffff;\n\tion-item {\n\t\tborder: none;\n\t\talign-items: flex-start;\n\t\tlabel {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n  }\n   \n .error-message {\n\tcolor: var(--ion-color-primary);\n    text-align: center;\n    padding: 20px;\n }\n .delivery {\n\ttext-align: center;\n    width: 100%;\n    display: flex\n;\n    justify-content: center;\n    padding: 10px;\n    color: black !important;\n\tspan {\n\t\tcolor: black;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t}\n }\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
